const load = (src) => {
    const stuff = require(`${src}`);
    if(stuff.default){
        return stuff.default;
    }
    return stuff;
};

export default load;